/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { BreadcrumbsBox } from "~/components";
import { CapacityForm } from "./CapacityForm";

export function AddCapacityPage() {
  return (
    <>
      <BreadcrumbsBox
        title="Add Billing Data"
        labels={[{ value: "add-billing-data", label: "Add Billing Data" }]}
      />
      <CapacityForm />
    </>
  );
}
